import React from 'react';
import { Handle, Position } from 'react-flow-renderer';


// Import CSS & assets
import './Nodes.css';
import close from '../../../../assets/ico/ico_close.svg';


const Node_Study_Destinations = ({ id, data }) => {

    var destinations = [
        { dest: "Exploitation agricole et forestière", subdest: "Exploitation agricole", status: "1", comment: "" },
        { dest: "Exploitation agricole et forestière", subdest: "Exploitation forestière", status: "1", comment: "" },
        { dest: "Habitation", subdest: "Logement", status: "1", comment: "" },
        { dest: "Habitation", subdest: "Hébergement ", status: "1", comment: "" },
        { dest: "Commerce et activités de service", subdest: "Artisanat et commerce de détail", status: "1", comment: "" },
        { dest: "Commerce et activités de service", subdest: "Restauration", status: "1", comment: "" },
        { dest: "Commerce et activités de service", subdest: "Commerce de gros", status: "1", comment: "" },
        { dest: "Commerce et activités de service", subdest: "Activités de services (accueil d'une clientèle)", status: "1", comment: "" },
        { dest: "Commerce et activités de service", subdest: "Cinéma", status: "1", comment: "" },
        { dest: "Commerce et activités de service", subdest: "Hôtels", status: "1", comment: "" },
        { dest: "Commerce et activités de service", subdest: "Autres hébergements touristiques", status: "1", comment: "" },
        { dest: "Équipements d'intérêt collectif et services publics", subdest: "Locaux et bureaux accueillant du public des administrations publiques", status: "1", comment: "" },
        { dest: "Équipements d'intérêt collectif et services publics", subdest: "Locaux techniques et industriels des administrations publiques", status: "1", comment: "" },
        { dest: "Équipements d'intérêt collectif et services publics", subdest: "Établissements d'enseignement", status: "1", comment: "" },
        { dest: "Équipements d'intérêt collectif et services publics", subdest: "Établissements de santé et d'action sociale", status: "1", comment: "" },
        { dest: "Équipements d'intérêt collectif et services publics", subdest: "Salles d'art et de spectacles", status: "1", comment: "" },
        { dest: "Équipements d'intérêt collectif et services publics", subdest: "Équipements sportifs", status: "1", comment: "" },
        { dest: "Équipements d'intérêt collectif et services publics", subdest: "Lieux de culte", status: "1", comment: "" },
        { dest: "Équipements d'intérêt collectif et services publics", subdest: "Autres équipements recevant du public", status: "1", comment: "" },
        { dest: "Autres activités des secteurs primaire, secondaire ou tertiaire", subdest: "Industrie", status: "1", comment: "" },
        { dest: "Autres activités des secteurs primaire, secondaire ou tertiaire", subdest: "Entrepôt", status: "1", comment: "" },
        { dest: "Autres activités des secteurs primaire, secondaire ou tertiaire", subdest: "Bureau", status: "1", comment: "" },
        { dest: "Autres activités des secteurs primaire, secondaire ou tertiaire", subdest: "Centre de congrès et d'exposition", status: "1", comment: "" },
        { dest: "Autres activités des secteurs primaire, secondaire ou tertiaire", subdest: "Cuisine dédiée à la vente en ligne", status: "1", comment: "" },
    ];
    var dest = Array(destinations.length).fill("1¤");
    var dest_string = dest.join("|");
    data.source[0].value = "Node_Study_Destinations[" + dest_string + "]";

    return (
        <div id={"block_" + id} className="ruleeditor__node_container">
            <div className="ruleeditor__node_title">
                <div className="ruleeditor__node_title_label">{data.label}</div>
                <div className="ruleeditor__node_title_close"><img src={close} alt="close_block" onClick={() => (data.handleDelete(id))} /></div>
            </div>
            <div className="ruleeditor__node_center">
                <div className="ruleeditor__node_description">{data.description}</div>
                <div className="ruleeditor__node_body">
                    <div className={`ruleeditor__handle_source_type ${data.source[0].value !== null ? "ruleeditor__handle_type_valid" : ""}`}>{data.source[0].acceptance}</div>
                </div>
            </div>
            <Handle type="source" position={Position.Right} style={{ top: 'calc(100% - 11px - 17px)' }} id="source_0" />
        </div>
    );
};

export default Node_Study_Destinations;